<template>
  <div class="index">
    <div class="left-box">
      <div class="top">
        <!-- 积分 -->
        <a-card class="card-box">
          <div class="card-header">
            <span>交易额 <i class="iconfont iconjinqian"></i></span>
            <a-select v-model="integralYear" style="width: 88px; text-align: center" @change="integralYearChange" >
              <a-icon type="caret-down" slot="suffixIcon" />
              <a-select-option :value="''" >全部</a-select-option>
              <a-select-option :value="item" v-for=" item in yearArr" :key="item">{{`${item}年`}}</a-select-option>
            </a-select>
          </div>
          <p class="total">总积分<span>￥{{pointsData.allPoints?pointsData.allPoints.toFixed(2):0}}</span></p>
          <div class="points-details">
            <div :style="{width: inPointsWidth, minWidth: '40%', maxWidth: '60%', backgroundColor: '#7acc61', color:'#fff'}">
              <p>已入账积分</p>
              <p style="font-weight: 900;">￥{{pointsData.inPoints?pointsData.inPoints.toFixed(2):0}}</p>
            </div>
            <div :style="{width: awaitPointsWidth, minWidth: '40%', maxWidth: '60%', backgroundColor: '#ebeef5'}">
              <p>待入账积分</p>
              <p style="font-weight: 900;">￥{{pointsData.awaitPoints?pointsData.awaitPoints.toFixed(2):0}}</p>
            </div>
          </div>
        </a-card>
        <!-- 图表 -->
        <a-card class="chart">
          <div class="card-header">
            <span>订单 <i class="iconfont icondingdan"></i></span>
            <div>
              <i class="moreLink" @click="goOrder('')"> 更多</i>
              <a-select v-model="orderYear" style="width: 88px" @change="orderYearChange" >
                <a-icon type="caret-down" slot="suffixIcon" />
                <a-select-option :value="''" >全部</a-select-option>
                <a-select-option :value="item" v-for=" item in yearArr" :key="item">{{`${item}年`}}</a-select-option>
              </a-select>
            </div>
          </div>
          <div class="info-box">
            <div id="myChart" :style="{width: '285px', height: '100%'}"></div>
            <div class="myorderStatus">
              <div>
                <p v-for="(item, index) in orderData" :key="item.name">
                  <i :class="bgColors[index]+' color-box'"></i>
                  <span>{{item.name}}：<i @click="goOrder(item.state)">{{item.value}}</i></span>
                  <span v-if="item.state.includes('1')">（退回：<i @click="goOrder('3')">{{Object.keys(withdraw)[0]}}</i>）</span>
                  <span v-if="item.state.includes('6')">（变更：<i @click="goOrder('8')">{{Object.keys(changeOrder)[0]}}</i>）</span>
                </p>
              </div>
            </div>
          </div>
        </a-card>
      </div>
      <div class="bottom">
        <div class="card-header">
          <span>订单金额统计</span>
          <div>
            <a-select v-model="realTimeYear" style="width: 88px" @change="realTimeYearChange" >
              <a-icon type="caret-down" slot="suffixIcon" />
              <a-select-option :value="item" v-for=" item in yearArr" :key="item">{{`${item}年`}}</a-select-option>
            </a-select>
            <!-- 月份，暂未开发 -->
            <!-- <a-select :default-value="0" style="width: 88px" @change="realTimeMonthChange" >
              <a-icon type="caret-down" slot="suffixIcon" />
              <a-select-option :value="item.value" v-for="item in month" :key="item.value">{{item.name}}</a-select-option>
            </a-select> -->
            <a-select v-model="seriesType" style="width: 88px" @change="realTimeSeriesTypeChange" >
              <a-icon type="caret-down" slot="suffixIcon" />
              <a-select-option :value="0" >订单数</a-select-option>
              <a-select-option :value="1" >总金额</a-select-option>
            </a-select>
          </div>
        </div>
        <div id="myLineChart" style="width:100%;height:100%;"></div>
      </div>
    </div>
    <div class="right-box">
      <div class="enterprise">
        <div class="card-header">
          <span>企业排名</span>
          <a-select v-model="rankYear" style="width: 88px" @change="rankYearChange" >
            <a-icon type="caret-down" slot="suffixIcon" />
            <a-select-option :value="''" >全部</a-select-option>
            <a-select-option :value="item" v-for=" item in yearArr" :key="item">{{`${item}年`}}</a-select-option>
          </a-select>
        </div>
        <a-row class="enterprise-head">
          <a-col :span="4"></a-col>
          <a-col :span="12">企业名称</a-col>
          <a-col :span="8">下单数量</a-col>
        </a-row>
        <a-row class="enterprise-item" v-for="(item, index) in enterpriseData" :key="index">
          <a-col :span="4">
            <i v-if="(index)<3 && (index)>=0" style="font-size:22px;" :class="`iconfont ${rank[index]} ${rankColors[index]}`"></i>
            <span v-else>{{index+1}}</span>
          </a-col>
          <a-col :span="12" style="text-align: left;">
            {{item.name}}
          </a-col>
          <a-col :span="8">
            {{item.num}}
          </a-col>
        </a-row>
      </div>
      <div class="news">
        <div class="new-title">
          <p>消息通知</p>
          <p><span @click="goNews"  style="color:#1890ff; font-size:14px; font-weight: 400; cursor: pointer;">更多</span></p>
        </div>
        <div class="new-item" v-for="(item, index) in dynamicList" :key="index">
          <div><i class="dots"></i></div>
          <div style="width:100%">
            <p><span>{{item.createTime|formatDate}}</span></p>
            <p class="nowrap-ellipsis" >{{item.content}}</p>
          </div>
        </div>
        
      </div>
    </div>
    <div class="right-menu">
        <ul>
            <li class="we-chat">
                <i class="iconfont icon">&#xe617;</i>
                <span class="max-text"><i class="iconfont">&#xe617;</i>微信咨询</span>
                <div class="we-img">
                    <div class="img"></div>
                </div>
            </li>
            <li>
                <i class="iconfont icon">&#xe613;</i>
                <span class="max-text"><i class="iconfont">&#xe613;</i>19906876274</span>
            </li>
            <li onclick="qimoChatClick()">
                <i class="iconfont icon">&#xe612;</i>
                <span class="max-text"><i class="iconfont">&#xe612;</i>在线咨询</span>
            </li>
        </ul>
    </div>
  </div>
</template>
<script>
import { 
  getIntegral, 
  getOrderForYear, 
  getDynamicList, 
  getRealTimeData, 
  getEnterpriseRanking ,
  getYearArr,
} from '@/api/labHome'
import {formatDate} from '@/utils/date';

export default {
  name:'labHome',
  data() {
    return {
      name:'labHome',
      integralYear: '',
      realTimeYear: '',
      orderYear: '',
      rankYear: '',
      yearArr:[],
      pointsData:{
        awaitPoints: 0,
        inPoints: 0,
        allPoints: 0
      },
      inPointsWidth:'',
      awaitPointsWidth:'',
      orderData:[],
      lineChartData:[],
      changeOrder:null,
      withdraw:null,
      enterpriseData:[],
      dynamicList:[],
      bgColors:['bgcFAC858', 'bgc73C0DE', 'bgcFFA3A3', 'bgc5470C6', 'bgc91CB74', 'bgcEE6666'],
      rankColors:[ 'colorAB0202',  'colorFAA658', 'colorFAC858' ],
      rank:['icon1', 'icon2', 'icon3'],
      month:[
        {value:0,name:'全年'},
        {value:1,name:'1月'},
        {value:2,name:'2月'},
        {value:3,name:'3月'},
        {value:4,name:'4月'},
        {value:5,name:'5月'},
        {value:6,name:'6月'},
        {value:7,name:'7月'},
        {value:8,name:'8月'},
        {value:9,name:'9月'},
        {value:10,name:'10月'},
        {value:11,name:'11月'},
        {value:12,name:'12月'},
      ],
      seriesType: 0,
    }
  },
  methods: {
    rankYearChange(value) {
      this.rankYear  = value;
      this.getEnterpriseRanking();
    },
    orderYearChange(value) {
      this.orderYear  = value;
      this.getOrderForYear();
    },
    integralYearChange(value) {
      this.integralYear = value;
      this.getIntegral();
    },
    realTimeYearChange(value) {
      this.realTimeYear = value;
      this.getRealTimeData();
    },
    realTimeMonthChange(value) {
      console.log(value,'月份');
    },
    realTimeSeriesTypeChange(value) {
      this.getRealTimeData();
    },
    // 饼图
    picChartInit() {
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      myChart.setOption({
          // tooltip: {
          //     trigger: 'item'
          // },
          color:['#FAC858', '#73C0DE', '#FFA3A3', '#5470C6', '#91CB74', '#EE6666'],
          series: [
              {
                  type: 'pie',
                  // radius: ['50%', '83%'],
                  radius: ['35%', '83%'],
                  avoidLabelOverlap: false,
                  itemStyle: {
                      borderRadius: 10,
                      borderColor: '#fff',
                      borderWidth: 1
                  },
                  label: {
                      show: false,
                      position: 'center'
                  },
                  emphasis: {
                      label: {
                          show: true,
                          fontSize: '14',
                          fontWeight: 'bold'
                      }
                  },
                  labelLine: {
                      show: false
                  },
                  data: this.orderData
              }
          ]
      });
    },
    // 折线图
    lineChartInit() {
      let myLineChart = this.$echarts.init(document.getElementById('myLineChart'),'light')
      let option = {
        tooltip: {
            trigger: 'axis'
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.lineChartData.xaxis
        },
        yAxis: {
            type: 'value'
        },
        series: this.lineChartData.series
      }
      myLineChart.setOption(option);
    },
    // 饼图数据
    getOrderForYear() {
      let params = this.orderYear;
      // params 为 '' 时，表示获取全部
      getOrderForYear(params)
        .then(res => {
          this.withdraw = res.withdraw;
          this.changeOrder = res.change;
          this.orderData = res.right;
          this.picChartInit();
        })
        .catch(error => {
          console.log(error);
        })
    },
    // 首页跳转至分类订单页
    goOrder(value) {
      this.$router.push({ name: 'orderManage', params: {'state': value}})
    },
    // 获取积分数据
    getIntegral() {
      // year 为 '' 时，获取全部积分
      let params = this.integralYear;
      getIntegral(params)
      .then(res => {
        this.pointsData = res;
        if(res.allPoints != 0) {
          let width = parseInt((res.inPoints / res.allPoints) * 100);
          this.inPointsWidth = `${width}%`;
          this.awaitPointsWidth = `${100-width}%`;
        }else {
          this.inPointsWidth = '50%';
          this.awaitPointsWidth = '50%';
        }
        
      })
      .catch(error => {
        console.log(error);
      })
    },
    // 获取动态订单
    getDynamicList() {
      getDynamicList()
      .then(res => {
        // console.log(res, '动态订单');
        this.dynamicList = res;
      })
      .catch(error => {
        console.log(error);
      })
    },
    // 折线图数据
    getRealTimeData() {
      let params = {
        id: this.seriesType,
        year:this.realTimeYear
      };
      getRealTimeData(params)
      .then(res => {
        // console.log(res, '折线图');
        this.lineChartData = res
        this.lineChartInit();
      })
      .catch(error => {
        console.log(error);
      })
    },
    getEnterpriseRanking() {
      let params = this.rankYear;
      getEnterpriseRanking(params)
        .then(res => {
          // console.log(res, '企业排名');
          this.enterpriseData = res;
        })
        .catch(error => {
          console.log(error);
        })
    },
    getYearArr() {
      getYearArr()
      .then(res => {
        this.yearArr = res;
      })
      .catch(error => {
        console.log(error);
      })
    },
    // 设置数据的默认年份
    setYear() {
      let date = new Date();
      // this.integralYear = date.getFullYear();
      this.realTimeYear = date.getFullYear();
    },
    goNews () {
      this.$router.push({name:'informCenter'});
    },

  },
  mounted() {
    this.getYearArr();
    this.setYear();
    // 钩子
    // 订单
    this.getOrderForYear();
    // this.lineChartInit();
    // 积分数据
    this.getIntegral();
    // 折线图数据
    this.getRealTimeData();
    // 企业排名
    this.getEnterpriseRanking();
    this.getDynamicList();

  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
}
</script>
<style lang="less" scoped>
.index {
  display: flex;
  height: 100%;
  background-color: #fff;
  padding: 40px 30px 20px;
  .left-box {
    width: 65%;
    height: 100%;
    // background-color: #b2d1a8;
    .top {
      display: flex;
      height: 320px;
      justify-content:space-between;
      .card-box {
        width: 42%;
        border-radius: 4px;
        border: 1px solid #ebeef5;
        background-color: #fff;
        overflow: hidden;
        transition: .3s;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        .total{
          height: 135px;
          line-height: 135px;
          font-weight: 900;
          text-align: center;
          font-size: 16px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          span {
            color: #fc2441;
            font-size: 28px;
          }
        }
        .points-details {
          display: flex;
          justify-content: center;
          white-space: nowrap;
          overflow: hidden;
          font-size: 16px;
          div {
            padding: 5px;
            p {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: center;
            }
          }
        }
      }
      .chart {
        height: 100%;
        width: 57%;
        border-radius: 4px;
        border: 1px solid #ebeef5;
        background-color: #fff;
        overflow: hidden;
        transition: .3s;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        #myChart {
          margin: 0;
          height: 100%;
        }
        /deep/.ant-card-body {
          // display: flex;
          width: 100%;
          height: 100%;
        }
        .info-box {
          display: flex;
          width: auto;
          // min-width: 190px;
          height: 96%;
          // border: 1px solid #000;
          .myorderStatus{
            display: flex;
            flex-direction: column;
            justify-content: center;
            p {
              width: 100%;
              margin-bottom: 8px;
              span {
                i {
                  color: #409eff;
                  cursor: pointer;
                }
              }
            }
          }
        }
        
      }
    }
    .bottom {
      width: 100%;
      height: 50%;
      margin-top: 25px;
      #myLineChart {
        width: 100%;
        height: 100%;
      }
    }
    
  }
  .right-box {
    width: 35%;
    height: 100%;
    padding-left: 2%;
    .enterprise{
      height: 320px;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      overflow: hidden;
      transition: .3s;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      padding: 15px 15px 10px;
      /deep/.ant-select-selection {
        border: none;
      }
      /deep/.ant-select-arrow{
        color: #000;
      }
      /deep/.ant-select-open .ant-select-selection:hover{
        box-shadow: none;
      } 
      /deep/.ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active {
        box-shadow: none!important;;
      }
      .enterprise-head {
        color:#666;
        height:30px;
        line-height: 30px;
        text-align: center;
      }
      .enterprise-item {
        position: relative;
        z-index: 1000;
        height:30px;
        line-height: 30px;
        text-align: center;
        background:rgba(0,0,0,0,1);
      }
    }
    .news {
      border-radius: 4px;
      border: 1px solid #ebeef5;
      background-color: #fff;
      overflow: hidden;
      transition: .3s;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      padding: 15px;
      margin-top: 20px;
      .new-title {
        display: flex;
        justify-content: space-between;
        font-size: 20px;
        font-weight: 900;
        margin-bottom: 10px;
      }
      .new-item {
        display: flex;
        position: relative;
        // height: 3px;
        // line-height: 30px;
        vertical-align: middle;
        margin-bottom: 5px;
        div {
          height: 50px;
          line-height:50px;
          p {
            line-height:25px;
          }
        }
        .dots{
          display: inline-block;
          // position: absolute;
          // top: 50%;
          // margin-top: -4px;
          margin-right: 10px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: rgb(233, 132, 132);
        }
      }
    }
  }
  .right-menu {
    width: 45px;
    border-radius: 4px;
    min-height: 350px;
    /* display: flex; */
      /* -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
    flex-direction: column; */
    position: fixed;
    z-index: 999;
    right: 0;
    bottom: 200px;
    li {
      width: 45px;
      height: 48px;
      line-height: 48px;
      background: rgba(53,63,88,0.66);
      border-bottom: 1px solid rgba(255, 255, 255, 0.4);
      cursor: pointer;
      color: #fff;
      text-align: center;
      font-size: 16px;
      position: relative;
      .we-img {
        position: absolute;
        width: 120px;
        height: 120px;
        left: -230px;
        top: 0;
        background-color: #fff;
        border-radius: 10px;
        display: none;
        .img {
          position: absolute;
          width: 90%;
          height: 90%;
          background: url('../../assets/images/small-public.png') center no-repeat;
          background-size: 100% 100%;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }
      .icon {
        position: absolute;
        z-index: 2;
        font-size: 24px;
        display: block;
        width: 100%;
        height: 100%;
        background: rgba(53,63,88,0.66);
        left: 0;
        top: 0;
        transition: left 1.2s;
      }
      .max-text {
        display: block;
        position: absolute;
        width: 160px;
        height: 48px;
        line-height: 48px;
        z-index: 3;
        left: 60px;
        top: -1px;
        background-image: linear-gradient(to right, rgb(90,211,151), rgba(0,175,131,1));
        color: #fff;
        border-radius: 5px 0 0 5px;
        font-size: 18px;
        transition: left 1s;
        padding: 0 10px;
        box-sizing: border-box;
        i{
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }
    li:last-child {
      border: none;
    }
    li:hover .max-text{
      left: -115px;
    }
    li:hover .icon {
      left: -20px;
    }
    .we-chat:hover .we-img{
      display: block;
    }
  }
}
.card-header {
  display: flex;
  justify-content:space-between;
  .moreLink {
    font-size: 12px;
    color: #409eff;
    cursor: pointer;
  }
  span {
    font-weight: 900;
    font-size: 20px;
    color: #222;
    .iconfont {
      font-size: 20px;
      font-weight: 400;
    }
  }
  /deep/.ant-select-selection {
    border: none;
  }
  /deep/.ant-select-arrow{
    color: #000;
  }
  /deep/.ant-select-open .ant-select-selection:hover{
    box-shadow: none;
  } 
  /deep/.ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active {
    box-shadow: none!important;;
  }
  /deep/.ant-select-selection-selected-value {
    width: 100%;
    text-align: center;
  } 
}
.bgcFAC858 {
  background-color: #FAC858!important;
}
.bgc73C0DE {
  background-color: #73C0DE!important;
}
.bgcFFA3A3 {
  background-color: #FFA3A3!important;
}
.bgc5470C6 {
  background-color: #5470C6!important;
}
.bgc91CB74 {
  background-color: #91CB74!important;
}
.bgcEE6666 {
  background-color: #EE6666!important;
}
.colorFAC858{
  color: #FAC858!important;
}
.colorFAA658{
  color: #faa658!important;
}
.colorAB0202{
  color: #ad0202!important;
}
.color-box {
  display: inline-block;
  border-radius: 3px;
  margin-right: 5px;
  width: 15px;
  height: 10px;
}
.nowrap-ellipsis {
  display: block;
  width:99%;
  text-align: left!important;
  white-space: nowrap!important;
  overflow: hidden!important;
  text-overflow: ellipsis!important;
  color: #666;
}


</style>